import { useTranslate } from '@growtherapy/i18n';

import { BlockedPermissionDescription } from '../BlockedPermissionDescription';
import { HelpModalItem } from './HelpModalItem';

export type BlockedPermissionsActionItemProps = {
  isMobile: boolean;
  isSafari: boolean;
  isDarkTheme: boolean;
};

export function BlockedPermissionsActionItem({
  isMobile: isMobileDevice,
  isSafari,
  isDarkTheme,
}: BlockedPermissionsActionItemProps) {
  const t = useTranslate();
  return (
    <HelpModalItem
      heading={t('telehealth-core:troubleshooting.myCameraAndMicArentWorking')}
      description={
        <div className='flex flex-col gap-4'>
          <BlockedPermissionDescription isMobile={isMobileDevice} isSafari={isSafari} isDarkTheme={isDarkTheme} />
        </div>
      }
    />
  );
}
